// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as VehicleRepo from "./VehicleRepo.bs.js";
import * as DummyVehicleRepo from "./DummyVehicleRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            fetchVehicleTypes: DummyVehicleRepo.VehicleRepo.fetchVehicleTypes,
            useVehicleTypes: DummyVehicleRepo.VehicleRepo.useVehicleTypes
          };
  } else {
    return VehicleRepo.VehicleRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
